/**************************************************
 * Nombre:       Dialogo_Carrito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, IconButton} from "@mui/material";
import {usePasosFormularios} from "../../Modulo_Pasos/Hooks/usePasosFormularios";
import {useFuncionesCarrito} from "../Hooks/useFuncionesCarrito";
import Formulario_Lista_Productos from "../Formularios/Formulario_Lista_Productos";
import {Close} from "@mui/icons-material";
import Formulario_Direccion from "../Formularios/Formulario_Direccion";
import {envioMensajeWass} from "../Utilidades/envioMensajeWass";
import {obtenerTotalProductos} from "../Utilidades/obtenerTotalProductos";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";
import {useState} from "react";
import {guardarObjLocal} from "../../Servicios/BDLocal/guardarObjLocal";
import {obtenerObjLocal} from "../../Servicios/BDLocal/obtenerObjLocal";

const Dialogo_Carrito = ({cerrar}) => {
    const {productos, limpiarCarrito} = useFuncionesCarrito()
    const {Pasos, obtenerEntidad} = usePasosFormularios({
        datos: {productos: productos, guardar: true},
        formularios: [
            Formulario_Lista_Productos,
            Formulario_Direccion
        ]
    })
    const [cargando, setCargando] = useState(false)


    const subirDatosCarrito = async (e) => {


        setCargando(true)
        let entidad = e
        entidad.fecha = new Date().getTime()
        entidad.estado = 'Nuevo'
        entidad.valor = obtenerTotalProductos(entidad.productos)

        let num = await obtenerConsecutivo({col: 'consecutivos', id: 'pedidos'})
        if (!num.res) return

        console.log(entidad)

        if (entidad.guardar) {
            guardarDatosLocal(entidad)
        }

        guardarPedido(entidad)

        entidad.consecutivo = num.data
        let dox = await guardarDoc('pedidos', entidad)
        if (!dox.res) return

        await aumentarConsecutivo({col: 'consecutivos', id: 'pedidos', actual: entidad.consecutivo})

        envioMensajeWass(entidad)
        limpiarCarrito()
        setCargando(false)
        cerrar()



    }


    const guardarDatosLocal = (ent) => {

        let obj = {
            nombre: ent.nombre,
            ciudad: ent.ciudad,
            otraCiudad: ent.otraCiudad ? ent.otraCiudad : '',
            direccion: ent.direccion,
            celular: ent.celular,
            otroCelular: ent.otroCelular ? ent.otroCelular : '',
            indicaciones: ent.indicaciones ? ent.indicaciones : '',
            cc: ent.cc ? ent.cc : ''
        }

        guardarObjLocal({key: 'usuario', obj: obj})

    }

    const guardarPedido = (entidad) => {

        let productos = entidad.productos
        let fecha = entidad.fecha

        let arrPedidos = []
        let pedidosGuardados = obtenerObjLocal({key: 'pedidos'})
        if (pedidosGuardados) {
            arrPedidos = pedidosGuardados
        }

        let obj = {
            productos: productos,
            fecha: fecha
        }

        arrPedidos.push(obj)
        guardarObjLocal({key: 'pedidos', obj: arrPedidos})

    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                <IconButton onClick={() => cerrar()}><Close/></IconButton>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{px: 3}}>
                <Pasos finalizar={subirDatosCarrito} cargando={cargando}/>
            </Grid>

        </Grid>
    )

}
export default Dialogo_Carrito